// @ts-ignore
import { getUserPermissions } from "@viuti/recursos";

export const validateAccess = (href: string, accessId: string) => {
  if (!accessId) return (window.location.href = href);

  const userPermissions = getUserPermissions();
  const permissions = userPermissions.accessKeyModules;
  const companyPlan = userPermissions.plan;
  const selectedAccess = permissions.find((p) => p.id === accessId);

  if (!selectedAccess) {
    const accessDeniedEvent = new CustomEvent("access-denied", {
      detail: { accessId },
    });
    window.dispatchEvent(accessDeniedEvent);
    // OJO: aquí NO se vuelve a bloquear por "plan 1 y no es trial". Esa
    // condición asumía que todo local en plan 1 sin trial era una cuenta
    // degradada, y le cerraba TODA la navegación a un cliente que compró el
    // plan Emprendedor (que es plan 1 y ya no es trial). El gate real por plan
    // lo aplica el backend en GET /Account/CheckPermission (code 3), que es la
    // vía que usa validateModuleAccess.
  } else if (selectedAccess.hierarchy > companyPlan.hierarchy) {
    const planDeniedEvent = new CustomEvent("plan-denied", {
      detail: { selectedAccess },
    });
    window.dispatchEvent(planDeniedEvent);
  } else {
    window.location.href = href;
  }
};
